<template>
    <div class="inner-box">
        <div class="title">방문신청 진행보기</div>
        <div class="title-s">방문신청 결과를 조회하여 진행 상태를 확인 할 수 있습니다.</div>

        <h1>신청자 정보</h1>
        <table class="visit-info-table">
            <colgroup>
                <col width="35%"></col>
                <col width="45%"></col>
                <col width="*"></col>
            </colgroup>
            <tr>
                <td class="tit">신청자명</td>
                <td style="border-right:1px solid #ddd">
                    <input class="input" type="text" placeholder="방문자명을 입력하세요." ref="visitSearchNm" v-model="searchInfo.visitSearchNm">
                </td>
                <td rowspan="2" style="text-align:center;padding:0px">
                    <button class="button-confirm" @click="search">
                        검색
                    </button>
                </td>
            </tr>
            <tr>
                <td class="tit">연락처</td>
                <td style="border-right: 1px solid #ddd">
                    <select style="padding:10px 25px 10px 10px" v-model="searchInfo.visitorMobile1">
                        <option
                                v-for="item in mobiles"
                                :key="item"
                                :value="item"
                                v-text="item"/>
                    </select>&nbsp;
                    <input class="input" type="text" maxlength="4" style="width:60px;" ref="visitorMobile2" v-model="searchInfo.visitorMobile2">&nbsp;
                    <input class="input" type="text" maxlength="4" style="width:60px;" ref="visitorMobile3" v-model="searchInfo.visitorMobile3">&nbsp;
                </td>
            </tr>
        </table>
        <div style="height:50px"></div>

        <div style="font-size: 13px;margin: 0 0 10px 10px;">총 {{this.visitInfoList.length}} 건</div>
        <div class="visit-info-list">
            <div class="visit-info-list_header mobile_hide">
                <ul>
                    <li class="list_1">
                        <p class="tit">
                            <span>No</span>
                        </p>
                    </li>
                    <li class="list_2">
                        <p class="tit">
                            <span>신청일</span>
                        </p>
                    </li>
                    <li class="list_3">
                        <p class="tit">
                            <span>이름</span>
                        </p>
                    </li>
                    <li class="list_4">
                        <p class="tit">
                            <span>소속회사</span>
                        </p>
                    </li>
                    <li class="list_5">
                        <p class="tit">
                            <span>방문기간</span>
                        </p>
                    </li>
                    <li class="list_6">
                        <p class="tit">
                            <span>피방문자</span>
                        </p>
                    </li>
                    <li class="list_7">
                        <p class="tit">
                            <span>상태</span>
                        </p>
                    </li>
                </ul>
            </div>
            <div v-if="this.visitInfoList.length==0">
                <table class="visit-list-table">
                    <tr>
                        <td style="text-align: center">검색 내용이 없습니다.</td>
                    </tr>
                </table>
            </div>
            <div v-else>
                <ul v-for="(row, index) in visitInfoList">
                    <li class="list_1">
                        <p class="tit m_show">
                            <span>No</span>
                        </p>
                        <div class="write" style="margin:0 auto;">
                            {{index + 1}}
                        </div>
                    </li>
                    <li class="list_2">
                        <p class="tit m_show">
                            <span>신청일</span>
                        </p>
                        <div class="write">
                            {{row.regDtm}}
                        </div>
                    </li>
                    <li class="list_3">
                        <p class="tit m_show">
                            <span>이름</span>
                        </p>
                        <div class="write">
                            {{row.visitorNm}}
                        </div>
                    </li>
                    <li class="list_4">
                        <p class="tit m_show">
                            <span>소속회사</span>
                        </p>
                        <div class="write">
                            {{row.visitorComp}}
                        </div>
                    </li>
                    <li class="list_5">
                        <p class="tit m_show">
                            <span>방문기간</span>
                        </p>
                        <div class="write">
                            {{row.staYmd}} ~ {{row.endYmd}}
                        </div>
                    </li>
                    <li class="list_6">
                        <p class="tit m_show">
                            <span>피방문자</span>
                        </p>
                        <div class="write">
                            {{row.empNm}}
                        </div>
                    </li>
                    <li class="list_7">
                        <p class="tit m_show">
                            <span>상태</span>
                        </p>
                        <div class="write">
                            <p v-if="row.visitStatCd=='내부결재중'"><span style="color:#008000">{{row.visitStatCd}}</span></p>
                            <p v-else-if="row.visitStatCd=='반려'"><span style="color:#FF0000">{{row.visitStatCd}}</span></p>
                            <p v-else-if="row.visitStatCd=='방문종료'"><span style="color:#FF0000">{{row.visitStatCd}}</span></p>
                            <p v-else><span style="color:#0000FF">{{row.visitStatCd}}</span></p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div style="height:100px"></div>

    </div>
</template>

<script>
    export default {
        name: "Status",
        data(){
            return {
                mobiles:['010','011','016','017','018','019'],
                listTotalNum:0,

                searchInfo:{
                    compCd: "E0000001",
                    visitSearchNm:"",
                    visitorMobile:"",
                    visitorMobile1: "010",
                    visitorMobile2: "",
                    visitorMobile3: "",
                },
                visitInfoList:'',
            }
        },
        methods: {
            search() {
                const reg1 = /(\d{3,4})/;
                const reg2 = /(\d{4})/;

                if(this.searchInfo.visitSearchNm==""){
                    setTimeout(()=> {
                        this.$swal({type: 'warning', text: '방문자명을 입력해주세요.'}).then(() => {
                        })
                    ,10})
                    this.$refs.visitSearchNm.focus();
                    return false;
                }

                if(this.searchInfo.visitorMobile2 == ""){
                    setTimeout(()=> {
                        this.$swal({type: 'warning', text: '연락처를 입력하세요.'}).then(() => {
                        })
                            ,10})
                    this.$refs.visitorMobile2.focus();
                    return false;
                }

                if(!reg1.test(this.searchInfo.visitorMobile2)){
                    setTimeout(()=> {
                        this.$swal({type: 'warning', text: '연락처를 정확히 입력하세요.'}).then(() => {
                        })
                            ,10})
                    this.$refs.visitorMobile2.focus();
                    return false;
                }

                if(this.searchInfo.visitorMobile3 == ""){
                    setTimeout(()=> {
                        this.$swal({type: 'warning', text: '연락처를 입력하세요.'}).then(() => {
                        })
                            ,10})
                    this.$refs.visitorMobile3.focus();
                    return false;
                }

                if(!reg2.test(this.searchInfo.visitorMobile3)){
                    setTimeout(()=> {
                        this.$swal({type: 'warning', text: '연락처를 정확히 입력하세요.'}).then(() => {
                        })
                            ,10})
                    this.$refs.visitorMobile3.focus();
                    return false;
                }

                const param = JSON.parse(JSON.stringify(this.searchInfo));
                this.$store.commit('loading');

                this.$http.post(`/api/visit/status/list`, param)
                    .then(response => {
                        if (response.data) {
                            this.visitInfoList = response.data;
                            if(this.visitInfoList.length == 0){
                                this.$swal({type: 'info', text: '검색 된 내용이 없습니다.'});
                            }
                        }
                    }).finally(() => {
                    this.$store.commit('finish')
                });

            },
        },
        computed: {
            years () {
                const year = new Date().getFullYear() - 18; //만18세 이상
                return Array.from({length: 53}, (value, index) => year - index);  //70세까지
            }
        },
        watch: {
            'searchInfo' : {
                immediate: true,
                deep: true,
                handler(){
                    const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
                    this.searchInfo.visitorMobile = this.searchInfo.visitorMobile1 + this.searchInfo.visitorMobile2 + this.searchInfo.visitorMobile3;

                    if(reg.exec(this.searchInfo.visitorMobile2)!==null){
                        this.searchInfo.visitorMobile2 = this.searchInfo.visitorMobile2.replace(/-/g, '').replace(/[^0-9]/g,'');
                    }
                    if(reg.exec(this.searchInfo.visitorMobile3)!==null){
                        this.searchInfo.visitorMobile3 = this.searchInfo.visitorMobile3.replace(/-/g, '').replace(/[^0-9]/g,'');
                    }
                },
            },

        },

    }
</script>

<style scoped>
    .inner-box{
        height: 100%;
        width:95%;
        left: 0;
        right: 0;
        margin: 0 auto 13%;
    }

    .title{
        font-size:40px;
        text-align:center;
        margin-top:50px;
        padding:0px 0;
    }

    .title-s{
        font-size:15px;
        color:#666;
        text-align:center;
        padding:0 0 30px 0;
    }

    .inner-box h1{
        font-size:20px;
        padding:50px 0 10px 0;
        font-weight: bold;
    }

    .inner-box button{
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
        font-weight: bold;
    }

    .inner-box .button-confirm{
        background-color: #3f3f3f;
        color:#fff;
        width:70px;
    }

    table.visit-info-table{
        border-top: 1px solid #aaaaaa;
        width: 100%;
    }

    table.visit-info-table td {
        border-bottom: 1px solid #ddd;
        color: #999;
        padding: 15px 0 15px 15px;
        font-size: 14px;
        vertical-align: middle;
    }

    table.visit-info-table td input{
        width: 70%;
        height: 40px;
        display: inline-block;
    }

    table.visit-info-table td p input{
        width: 100%;
    }

    table.visit-info-table td select{
        padding:10px 40px 10px 15px;
    }

    table.visit-info-table td.tit{
        background: #f9f9f9;
        padding-left: 30px;
        color: #666;
        line-height: normal;
    }

    table.visit-info-table td.tit-c{
        background: #f9f9f9;
        color: #666;
        line-height: normal;
        text-align: center;
    }

    table.visit-info-table td.list-c{
        text-align: center;
    }

    table.visit-info-table td button{
        margin-left:10px;
    }

    table.visit-list-table{
        border-top: 1px solid #aaaaaa;
        width: 100%;
    }

    table.visit-list-table td {
        border-bottom: 1px solid #ddd;
        color: #999;
        padding: 15px 0 15px 15px;
        font-size: 14px;
        vertical-align: middle;
    }

    .visit-info-list ul{
        border-top: 1px solid #333;
        border-right: 0px;
        border-left: 0px;
    }

    .visit-info-list ul li {
        float: none;
        display: table;
        table-layout: fixed;
        width: 100%;
        text-align: left;
        border-bottom: 1px solid #ddd;
    }

    .visit-info-list ul li .tit.m_show {
        display: table-cell;
        padding: 10px 0 10px 10px;
    }

    .visit-info-list ul li .tit {
        padding-left: 10px;
        color: #666;
        background: #f9f9f9;
        display: table-cell;
        width: 35%;
        vertical-align: middle;
        font-size: 14px;
    }

    .visit-info-list ul li .write {
        text-align: left;
        padding: 10px 0 10px 10px;
        vertical-align: middle;
        font-size: 14px;
    }

    .mobile_hide {
        display: none;
    }

    @media (min-width: 1000px) {
        .inner-box{
            width:1000px;
        }

        .mobile_hide {
            display: inline;
            margin:0px;
            padding:0px;
        }

        table.visit-list-table{
            border-top: 1px solid #ffffff;
            width: 100%;
        }

        .visit-info-list ul li .tit.m_show {
            display: none;
        }

        .visit-info-list ul {
            border-top: 0px;
            table-layout: fixed;
            display: table;
            width: 100%;
        }

        .visit-info-list .visit-info-list_header ul {
            border-top: 1px solid #333;
            display: table;
            table-layout: fixed;
            width: 100%;
        }

        .visit-info-list .visit-info-list_header ul li {
            display: table-cell;
            float: none;
            vertical-align: middle;
            padding: 15px 0;
        }

        .visit-info-list ul li {
            overflow: hidden;
            border-bottom: 1px solid #ddd;
            display: table-cell;
            width: 8%;
            text-align: center;
            vertical-align: middle;
        }

        .visit-info-list ul li .tit {
            color: #333;
            line-height: normal;
            background: #ffffff;
            font-size: 14px;
            width: 24%;
        }

        .visit-info-list ul li .write {
            padding: 10px 0 10px 5px;
            width: 100%;
            text-align: center;
        }

        .visit-info-list ul li.list_1 {
            width: 5%;
        }

        .visit-info-list ul li.list_2 {
            width: 15%;
        }

        .visit-info-list ul li.list_3 {
            width: 15%;
        }

        .visit-info-list ul li.list_4 {
            width: 20%;
        }

        .visit-info-list ul li.list_5 {
            width: 20%;
        }

        .visit-info-list ul li.list_6 {
            width: 15%;
        }

        .visit-info-list ul li.list_7 {
            width: 10%;
        }

    }
</style>